import { View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Text } from '@/components/ui/text';
import { Icon } from '~/global/components/icon/Icon';

interface MeasurementSourceBadgeProps {
  /** `MeasurementSource` value: APPLE_HEALTH | HEALTH_CONNECT | MANUAL. */
  source: string;
  testID?: string;
}

const SOURCE_LABEL_KEYS: Record<string, string> = {
  APPLE_HEALTH: 'settings.bodyMetrics.sourceAppleHealth',
  HEALTH_CONNECT: 'settings.bodyMetrics.sourceHealthConnect',
  MANUAL: 'settings.bodyMetrics.sourceManual',
};

/**
 * Small pill showing where a body measurement came from (Apple Health / Health
 * Connect / manual entry). Reused on the Profile Body Metrics card and the
 * body-composition trend screen.
 */
export const MeasurementSourceBadge = ({
  source,
  testID,
}: MeasurementSourceBadgeProps) => {
  const { t } = useTranslation('user');
  const iconName = source === 'MANUAL' ? 'Pencil' : 'HeartPulse';
  const labelKey =
    SOURCE_LABEL_KEYS[source] ?? 'settings.bodyMetrics.sourceManual';

  return (
    <View
      testID={testID}
      className="flex-row items-center gap-1 self-start rounded-full bg-surface-elevated px-2 py-1"
    >
      <Icon name={iconName} size={12} className="text-accent" />
      <Text className="text-xs text-text-secondary">{t(labelKey)}</Text>
    </View>
  );
};
